import React from 'react';
import { 
  HiMenu,
  HiPaperAirplane,
  HiArrowUp,
  HiUser,
  HiLogout,
  HiCog,
  HiPaperClip,
  HiGlobeAlt,
  HiShieldCheck,
  HiTrash,
  HiX,
  HiChevronDown,
  HiPencil,
  HiSave,
  HiPlus,
  HiClipboard,
  HiDesktopComputer,
  HiRefresh
} from 'react-icons/hi';
import { GiRollingDices } from "react-icons/gi";
import { IoCopyOutline, IoDiceSharp } from "react-icons/io5";

export const MenuIcon = ({ size = 20, className = "" }) => (
  <HiMenu size={size} className={className} />
);

export const SendIcon = ({ size = 20, className = "" }) => (
  <HiPaperAirplane size={size} className={className} />
);

export const ArrowUpIcon = ({ size = 20, className = "" }) => (
  <HiArrowUp size={size} className={className} />
);

export const UserIcon = ({ size = 20, className = "" }) => (
  <HiUser size={size} className={className} />
);

export const LogoutIcon = ({ size = 20, className = "" }) => (
  <HiLogout size={size} className={className} />
);

export const SettingsIcon = ({ size = 20, className = "" }) => (
  <HiCog size={size} className={className} />
);

export const AttachmentIcon = ({ size = 20, className = "" }) => (
  <HiPaperClip size={size} className={className} />
);

export const GlobeIcon = ({ size = 20, className = "" }) => (
  <HiGlobeAlt size={size} className={className} />
);

export const AdminIcon = ({ size = 20, className = "" }) => (
  <HiShieldCheck size={size} className={className} />
);

export const ClearIcon = ({ size = 20, className = "" }) => (
  <HiTrash size={size} className={className} />
);

export const CloseIcon = ({ size = 20, className = "" }) => (
  <HiX size={size} className={className} />
);

export const ChevronDownIcon = ({ size = 20, className = "" }) => (
  <HiChevronDown size={size} className={className} />
);

export const EditIcon = ({ size = 16, className = "" }) => (
  <HiPencil size={size} className={className} />
);

export const DeleteIcon = ({ size = 16, className = "" }) => (
  <HiTrash size={size} className={className} />
);

export const SaveIcon = ({ size = 16, className = "" }) => (
  <HiSave size={size} className={className} />
);

export const AddIcon = ({ size = 16, className = "" }) => (
  <HiPlus size={size} className={className} />
);

export const ModelIcon = ({ size = 16, className = "" }) => (
  <HiDesktopComputer size={size} className={className} />
);

export const ClipboardIcon = ({ size = 20, className = "" }) => (
  <IoCopyOutline size={size} className={className} />
);

export const DiceIcon = ({ size = 22, className = "" }) => (
  <IoDiceSharp size={size} className={className} />
);